export default __webpack_public_path__ + "045a7129e45cd6478e80f826449a1953.png";